import { CopyTwoTone, EditOutlined, InfoCircleFilled } from "@ant-design/icons";
import { ToastService } from "@shared/lib/services";
import {
  IInfluencer,
  INFLUENCER_ACCOUNT_STATUS,
} from "@shared/lib/types/influencer";
import { Button } from "@shared/ui/Button";
import { Col, Image, Rate, Row, Space, Tag, Typography } from "antd";
import styles from "./styles.module.scss";

const { Title, Text } = Typography;

interface Props {
  influencer?: IInfluencer;
  handleEditClick: () => void;
  socialMediaId?: string;
  creatorInfo?: {
    name?: string;
    image?: string;
    username?: string;
  };
  isOnboarded?: boolean;
  isV2?: boolean;
}

export function InfluencerCard({
  influencer,
  handleEditClick,
  socialMediaId,
  creatorInfo,
  isOnboarded = false,
  isV2 = false,
}: Props) {
  return (
    <div className={styles.card}>
      <Space
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "start",
          padding: "10px 0",
        }}
      >
        <Space
          style={{
            gap: 20,
          }}
        >
          <Image
            src={influencer?.profilePicUrl || creatorInfo?.image}
            className={styles.image}
          />
          <div className={styles.nameGrid}>
            <div className={styles.name}>
              {influencer?.firstName ? (
                <>
                  {influencer?.firstName} {influencer?.lastName}
                </>
              ) : (
                creatorInfo?.name || creatorInfo?.username
              )}
            </div>
            {influencer?.avgReview !== undefined && (
              <Rate disabled value={influencer.avgReview} />
            )}

            {influencer?.accountStatus ===
              INFLUENCER_ACCOUNT_STATUS.BLACKLISTED && (
              <Tag color={"red"} style={{ display: "block" }}>
                BlackListed
              </Tag>
            )}
            {socialMediaId && (
              <Row
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <Col>{socialMediaId}</Col>
                <Col>
                  <Button
                    onClick={() => {
                      navigator.clipboard.writeText(socialMediaId);
                      ToastService.success(
                        "Socialmedia Id Coapied To Clipboard"
                      );
                    }}
                    icon={<CopyTwoTone />}
                    style={{ border: 0 }}
                  />
                </Col>
              </Row>
            )}
          </div>
        </Space>
        {/* {showrighInfo && (
          <div style={{ display: "grid", gap: "5px" }}>
            {influencer?.type && (
              <Tag color="grey" style={{ width: "max-content" }}>
                {influencer.type}
              </Tag>
            )}
            {influencer?.phoneNumber && (
              <div>
                <span className={styles.label}>Phone: </span>
                <span className={styles.value}>
                  {influencer.countryCode} {influencer.phoneNumber}
                </span>
              </div>
            )}
            {influencer?.emailId && (
              <div>
                <span className={styles.label}>Email: </span>
                <span className={styles.value}>{influencer.emailId}</span>
              </div>
            )}
            {influencer?.locationGooglePlaceId && (
              <div>
                <span className={styles.label}>Location: </span>
                <TextWithTooltip
                  text={influencer.locationObj?.description}
                  limit={30}
                />
              </div>
            )}
            {influencer?.isAgency && (
              <div>
                <span className={styles.label}>Agency: </span>
                <span className={styles.value}>{influencer?.agency?.name}</span>
              </div>
            )}
          </div>
        )} */}
      </Space>
      {isV2 && !isOnboarded && (
        <Space align="start">
          <InfoCircleFilled
            // color="#1677FF"
            style={{ width: "24px", height: "24px", color: "#1677FF" }}
          />
          <div>
            <Title level={5} className={styles.onboardedTitle}>
              Influencer Not onboarded
            </Title>
            <Text className={styles.onboardedText}>
              Reach out through email or dm to get phone number, then create an
              influencer
            </Text>
          </div>
        </Space>
      )}
      {isOnboarded && (
        <div className={styles.footer}>
          <EditOutlined className={styles.icon} onClick={handleEditClick} />
        </div>
      )}
    </div>
  );
}
